var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    { staticClass: "category-menu-btn", class: _vm.rootClasses },
    [
      _c("category-menu-image", {
        attrs: {
          color: _vm.color,
          url: _vm.image.urls.default[0],
          alt: _vm.image.alt
        }
      }),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "category-menu-btn--content" },
        [
          _c("h2", { staticClass: "u-reset category-menu-btn--title" }, [
            _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
          ]),
          _vm._v(" "),
          _c("snake-pattern", {
            staticClass: "u-reset category-menu-btn--snake-pattern"
          }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "category-menu-btn--tile-icon" },
            [
              _c("ui-icon", {
                attrs: { symbol: "category-tiles", size: "medium" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e5bdd2c", { render: render, staticRenderFns: staticRenderFns })
  }
}